import { render, staticRenderFns } from "./DetalhesEventoRow.vue?vue&type=template&id=c864b994&scoped=true"
import script from "./DetalhesEventoRow.vue?vue&type=script&lang=ts"
export * from "./DetalhesEventoRow.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesEventoRow.vue?vue&type=style&index=0&id=c864b994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c864b994",
  null
  
)

export default component.exports